import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useParams } from 'react-router';

import { v4 as uuidv4 } from 'uuid';

import { faFileCheck } from '@fortawesome/pro-regular-svg-icons/faFileCheck';

import { RootState } from '../../../../app/rootReducer';
import { ReviewReinstatementDrawer } from '../../../detail/drawer/reinstatement/ReviewReinstatementDrawer';
import { SnackbarContext } from '../../SnackbarContext';
import NavLink from './NavLink';
import * as styles from './styles.module.scss';

export const InitiateReinstatement = () => {
  const copy = 'Initiate Reinstatement';
  const iconContainerClasses = `${styles.IconLinkContainer} ${styles.RightNavIconLinkContainer} ${styles.RightSidebar}`;
  const { openSnacks, setSnacks } = useContext(SnackbarContext);

  // For controlling the EvidenceDrawer component
  const [isOpen, setIsOpen] = useState(false);
  const openDrawer = () => {
    setIsOpen(true);
  };

  const {
    reinstatementError,
    reinstatementErrorType,
    reinstatementFailed,
  }: {
    reinstatementError: string | undefined;
    reinstatementErrorType: string | undefined;
    reinstatementFailed: boolean;
  } = useSelector((state: RootState) => {
    return {
      reinstatementError: state.application.reinstatementError,
      reinstatementErrorType: state.application.reinstatementErrorType,
      reinstatementFailed: state.application.reinstatementFailed,
    };
  });

  useEffect(() => {
    if (reinstatementFailed) {
      setSnacks([
        ...openSnacks,
        {
          id: uuidv4(),
          type: reinstatementErrorType,
          message: reinstatementError,
        },
      ]);
    }
  }, [reinstatementErrorType, reinstatementError, reinstatementFailed]);

  const { id } = useParams<{ id: string }>();
  if (!id) {
    return <Navigate to={{ pathname: '/' }} />;
  }

  return (
    <>
      <ReviewReinstatementDrawer
        applicationId={+id}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      />
      <NavLink
        icon={faFileCheck}
        iconClassName={styles.Icon}
        iconContainerClassName={iconContainerClasses}
        textClassName={styles.LinkRight}
        copy={copy}
        onClick={openDrawer}
      />
    </>
  );
};
